/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationCalendarPathParameters } from 'api/actions/get-reservation-calendar/get-reservation-calendar-path-parameters';
import { GetReservationCalendarResponse } from 'api/actions/get-reservation-calendar/get-reservation-calendar-response';

type GetReservationCalendarQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationCalendar action.
 */
export const getReservationCalendarActionPath = new SweetPath<keyof GetReservationCalendarPathParameters>(
  '/reservations/{reservationId}/calendar.ics',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationCalendar actions.
 */
export default function createGetReservationCalendarAction(axios: AxiosInstance) {
  return function getReservationCalendarAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationCalendarPathParameters;
    query?: GetReservationCalendarQueryParameters;
  }) {
    const path = getReservationCalendarActionPath.insert(parameters);

    return axios.get<GetReservationCalendarResponse, GetReservationCalendarResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
